import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { SessionStorageService } from "ngx-webstorage";
import { Router } from "@angular/router";
import "rxjs/add/operator/map";

declare var urlApi;

@Injectable()
export class ServiceService {
  urlApi: string;

  constructor(
    public http: Http,
    private session: SessionStorageService,
    private router: Router
  ) {
    this.urlApi = urlApi;
    console.log("Terkoneksi...");
  }

  serviceLogin(input) {
    return this.http
      .post(this.urlApi + "login", input)
      .map(data => data.json());
  }

  serviceGenSoal() {
    let token = this.getLogin().token;
    let data: any = this.http
      .post(this.urlApi + "genSoal/" + token, [])
      .map(data => data.json());
    return data;
  }

  serviceSimpanJawaban() {
    let token = this.getLogin().token;
    let jawaban = this.getNilai();
    let extra = this.getExtra();
    let data: any = this.http
      .post(this.urlApi + "simpanJawaban/" + token, {
        jawaban: JSON.stringify(jawaban),
        extra: JSON.stringify(extra)
      })
      .map(data => data.json());
    return data;
  }

  serviceSimpanAkhir() {
    let token = this.getLogin().token;
    let jawaban = this.getNilai();
    let extra = this.getExtra();
    let data: any = this.http
      .post(this.urlApi + "simpanAkhir/" + token, {
        jawaban: JSON.stringify(jawaban),
        extra: JSON.stringify(extra)
      })
      .map(data => data.json());
    return data;
  }

  serviceSimpanQuisioner(jawaban) {
    let token = this.getLogin().token;
    let data: any = this.http
      .post(this.urlApi + "simpanQuisioner/" + token, {
        jawaban: jawaban
      })
      .map(data => data.json());
    return data;
  }

  serviceGetSetting() {
    return this.http.get(this.urlApi + "getSetting").map(data => data.json());
  }

  checkLogin() {
    if (!this.session.retrieve("user")) {
      this.router.navigate(["/"]);
    }
    return this.session.retrieve("user");
  }

  getNilai() {
    return this.session.retrieve("nilai");
  }

  setNilai(nilai) {
    this.session.store("nilai", nilai);
  }

  getSoal() {
    return this.session.retrieve("soal");
  }

  setSoal(soal) {
    this.session.store("soal", soal);
  }

  getExtra() {
    return this.session.retrieve("extra");
  }

  setExtra(extra) {
    this.session.store("extra", extra);
  }

  getKategori() {
    return this.session.retrieve("kategori");
  }

  setKategori(kategori) {
    this.session.store("kategori", kategori);
  }

  getLogin() {
    return this.session.retrieve("user");
  }

  setLogin(login) {
    this.session.store("user", login);
  }

  getSetting() {
    return this.session.retrieve("setting");
  }

  setSetting(setting) {
    this.session.store("setting", setting);
  }

  clearAll() {
    this.session.clear();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/service.service.ts